import { Container, Row, Col, Input } from "reactstrap";
import SearchBox from "./SearchBox";
import "./Globals.css";
import { wrap } from "module";
import { getStatusStyles } from "../utils/Util";

/**Label and input props for IEC form details  */
interface IinputProps {
  placeHolder: string;
  label?: string;
  icon?: React.ReactElement;
  value?: string | number;
  onChange?: (e: any) => void;
  numberOnly?: boolean;
  fixedLabel: string;
  index?: number;
}

/**LabelINput Component */
export const LabelInput = (props: IinputProps) => {
  
  const getRowBackground = (index?: number) => {
    if (index === undefined) return "bg-light";
    return Math.floor(index / 2) % 2 === 0 ? "bg-light" : "bg-white";
  };

  return (
    <div>
      <Container>
        <Row>
          <Col
            className={`${getRowBackground(props.index)} border-bottom alignLabel`}
            style={{
              fontSize: 14,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              paddingTop : 10,
              paddingBottom : 10
            }}
          >
            <span style={['Status', 'KML ID']?.includes(props?.fixedLabel)? { fontWeight : 700 } : {}}>{props.fixedLabel}</span>
          </Col>
          
          <Col
            className={`${getRowBackground(props.index)} border-bottom alignLabel`}
            style={{
              fontSize: 14,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              paddingTop : 10,
              paddingBottom : 10
            }}
          >
            <span 
              id={props?.fixedLabel === 'Status' ? getStatusStyles(props?.placeHolder) : ""}
              style={['KML ID']?.includes(props?.fixedLabel)? { fontWeight : 700 } : {}}
            >{props.placeHolder}</span>
          </Col>
          
        </Row>
      </Container>
    </div>
  );
};